import { Orientations, PlaneView } from '../../../../view/views/PlaneView';
import { mat3 } from 'gl-matrix';
import { SvgCursor } from './SvgCursor';

const PLUS_SVG = [
    '<svg xmlns="http://www.w3.org/2000/svg"',
    ' width="16" height="16" viewBox="0 0 16 16">',
    '<line x1="8" y1="0" x2="8" y2="16"',
    ' stroke="white" stroke-width="2"/>',
    '<line x1="0" y1="8" x2="16" y2="8"',
    ' stroke="white" stroke-width="2"/>',
    '</svg>',
].join('');

const MINUS_SVG = [
    '<svg xmlns="http://www.w3.org/2000/svg"',
    ' width="16" height="16" viewBox="0 0 16 16">',
    '<path stroke="#fff" stroke-width="2"',
    ' d="M10 16h6M8 0v16M0 8h16"/>',
    '</svg>',
].join('');

export class TargetCrosshair extends SvgCursor {
    protected readonly _mode: boolean;
    protected readonly _draw: boolean;

    public constructor(view: PlaneView | null, mode: boolean, draw: boolean) {
        super(view ? [view] : null);
        this._mode = mode;
        this._draw = draw;
    }

    public getOrientationEnum(orientationMatrix: mat3): Orientations {
        const TRANSVERSAL_MATRIX = mat3.fromValues(1, 0, 0, 0, -1, 0, 0, 0, -1);
        const CORONAL_MATRIX = mat3.fromValues(0, -1, 0, 0, 0, 1, -1, 0, 0);
        const SAGITTAL_MATRIX = mat3.fromValues(1, 0, 0, 0, 0, 1, 0, -1, 0);

        if (mat3.equals(orientationMatrix, TRANSVERSAL_MATRIX)) {
            return Orientations.TRANSVERSAL_ORIENTATION;
        } else if (mat3.equals(orientationMatrix, CORONAL_MATRIX)) {
            return Orientations.CORONAL_ORIENTATION;
        } else if (mat3.equals(orientationMatrix, SAGITTAL_MATRIX)) {
            return Orientations.SAGITTAL_ORIENTATION;
        } else {
            throw new Error('Unknown orientation matrix');
        }
    }

    protected getSvgString(): string {
        return this._mode ? MINUS_SVG : PLUS_SVG;
    }

    protected getFallbackCursor(): string {
        return 'crosshair';
    }

    protected override getHotspot(): { x: number; y: number } {
        return { x: 8, y: 8 };
    }

    public override setCustomCursor(): void {
        if (this._draw) {
            super.setCustomCursor();
        } else {
            this.resetCursor();
        }
    }
}
